// extracted by mini-css-extract-plugin
export var absolute = "counter-dot-module--absolute--7c3c1";
export var wrapper = "counter-dot-module--wrapper--140a9";